import ES6Promise from 'es6-promise';
const Promise = window.Promise || ES6Promise;

// Needed for: IE 11, Edge, Safari
if (!Promise.allSettled) {
    Promise.allSettled = (promises) =>
        Promise.all(
            promises.map((promise) => promise
                .then((value) => ({
                    status: 'fulfilled',
                    value
                }))
                .catch((reason) => ({
                    status: 'rejected',
                    reason
                }))
            )
        );
}

export default Promise;
